var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-3-Copy-12",
    transform: "translate(-1224.000000, -6855.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 6410.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1121.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(103.736318, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    fill: "#17171B",
    x: 0,
    y: 0,
    width: 16.0199005,
    height: 16,
    rx: 2.61818182
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3.040140, 3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.73066486,1.36363636 C2.73066486,2.11675193 2.11938471,2.72727273 1.36533243,2.72727273 C0.61128015,2.72727273 0,2.11675193 0,1.36363636 C0,0.610520796 0.61128015,0 1.36533243,0 C2.11938471,0 2.73066486,0.610520796 2.73066486,1.36363636 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.42119442,3.63636364 L2.42119442,9.66090909 C2.42167402,9.75067399 2.38630985,9.83692846 2.32292768,9.90057315 C2.25954551,9.96421784 2.17337514,10.0000012 2.08349729,10.0000012 L0.644436906,10.0000012 C0.554559807,10.0002423 0.468293933,9.96469032 0.404740996,9.90121633 C0.341188058,9.83774234 0.305591879,9.75158363 0.305833232,9.66181818 L0.305833232,3.63636364 C0.305833232,3.44959098 0.457431941,3.29818182 0.644436906,3.29818182 L2.08349729,3.29818182 C2.27014669,3.29868294 2.42119442,3.44994542 2.42119442,3.63636364 L2.42119442,3.63636364 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94326231,6.77272727 L9.94326231,9.68909091 C9.94350366,9.77162319 9.91078445,9.85084505 9.85235248,9.90920444 C9.7939205,9.96756383 9.71460011,10.0002424 9.63196517,10.0000013 L8.08458842,10.0000013 C8.00195348,10.0002424 7.9226331,9.96756383 7.86420112,9.90920444 C7.80576914,9.85084505 7.77304994,9.77162319 7.77329263,9.68909091 L7.77329263,6.86272727 C7.77329263,6.44090909 7.89708277,5.01545455 6.6691938,5.01545455 C5.71801221,5.01545455 5.52413501,5.99090909 5.4859057,6.42909091 L5.4859057,9.68909091 C5.48592389,9.8590417 5.349305,9.99751534 5.17916101,10.0000013 L3.68457711,10.0000013 C3.60209979,10.0000013 3.52301375,9.96721497 3.46477893,9.90888193 C3.40654411,9.85054888 3.37394967,9.77146542 3.37419021,9.68909091 L3.37419021,3.61 C3.37394967,3.52762549 3.40654411,3.44854203 3.46477893,3.39020898 C3.52301375,3.33187594 3.60209979,3.29909055 3.68457711,3.29909091 L5.17916101,3.29909091 C5.35108493,3.29909091 5.49045681,3.43828965 5.49045681,3.61 L5.49045681,4.13545455 C5.8436228,3.60636364 6.36700023,3.19818182 7.48384215,3.19818182 C9.95782451,3.19818182 9.94326231,5.50545455 9.94326231,6.77272727 L9.94326231,6.77272727 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b751dd7776fea7babd233d7aaafda90e.svg";
export { ForwardRef as ReactComponent };